const compareString = (a, b) => {
  if(a > b) return 1;
  if(a < b) return -1;
  return 0;
};

export function sortCompareByType(sortBy) {
  return (p1, p2) => {
    switch(sortBy) {
    case 'date':
      return p2.date - p1.date;
    case 'type':
      return compareString(p2.type, p1.type);
    case 'ref':
      return compareString(p2.ref, p1.ref);
    case 'amount':
      return p2.amount - p1.amount;
    }
    return 0;
  };
}

export function sortCompareDefault(sortBy) {
  return (p1, p2) => {
    return compareString(p2[sortBy], p1[sortBy]);
  };
}
